import styled from "styled-components";
import Typography from "common/Typography/Typography";
import { hexToRGB } from "@shared/utils/misc";
import { typography } from "@shared/common/Themes/typography";
import { phoneMinWidth } from "common/NewLook/layout.ts";

const Link = styled(Typography).attrs((p: any) => {
  return {
    as: p.as ?? "a",
    $weight: p.$weight ?? typography.fontWeights.NORMAL,
    $size: p.$size ?? typography.fontSizes.M,
  };
})`
  cursor: pointer;
  color: ${(p) => p.theme.colors.primaryBlue} !important;
  &:hover {
    @media (min-width: ${phoneMinWidth}) {
      color: ${(p) => hexToRGB(p.theme.colors.primaryBlue, 0.8)} !important;
    }
  }
`;

export default Link;
